<!-- Header da Página -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-file"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'fatura.texts.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'fatura.texts.subtitulo' | translate }}</p>
  </div>
</div>

<div class="container mt-1 pt-0">
    <div class="card py-4 px-6 md:px-8 overflow-auto">
        <!-- Secao Informacoes do Cliente/Fornecedor -->
        <div class="fatura-info-section">
            <div class="fatura-info-row flex flex-column lg:flex-row lg:align-items-center lg:justify-content-between w-full">
                <div class="fatura-info-cliente flex flex-column mb-3 lg:mb-0">
                    <div class="fatura-section-label text-left">
                        <i class="pi pi-user mr-2"></i>
                        <ng-container *ngIf="ehTipoDeTransacaoVenda || ehTipoDeTransacaoDevolucao; else outraPagina">
                            {{ 'fatura.texts.informacoes_do_cliente' | translate }}
                        </ng-container>
                        <ng-template #outraPagina>
                            <ng-container
                                *ngIf="ehTipoDeTransacaoCompra || ehTipoDeTransacaoDevolucaoDeCompra; else defaultPage">
                                {{ 'fatura.texts.informacoes_do_fornecedor' | translate }}
                            </ng-container>
                            <ng-template #defaultPage>
                                {{ 'fatura.texts.informacoes_da_fatura' | translate }}
                            </ng-template>
                        </ng-template>
                    </div>
                    <div class="fatura-pessoa-nome text-left">
                        {{form.pessoa_id}} - {{form.nomePessoa}}
                    </div>
                </div>

                <!-- coluna com botoes -->
                <div class="fatura-info-acoes flex flex-column flex-wrap gap-2 w-full lg:w-auto lg:flex-row lg:justify-content-end">
                    <span *ngIf="!form.ehFaturaLegal"
                        [pTooltip]="notaCancelada ? ('fatura.tooltips.acao_nao_permitida_nota_cancelada' | translate) : 'Ctrl+L'"
                        tooltipPosition="bottom"
                        class="w-full lg:w-auto">
                        <button pButton
                            icon="pi pi-file-edit" class="p-button-outlined w-full"
                            [disabled]="notaCancelada"
                            [style.pointer-events]="notaCancelada ? 'none' : 'auto'"
                            (click)="abrirDialogoFaturaLegal()">
                            {{ 'fatura.botoes.fatura_legal' | translate }} (Ctrl+L)
                        </button>
                    </span>
                    <span *ngIf="ehTipoDeTransacaoVenda || ehTipoDeTransacaoCompra"
                        [pTooltip]="devolucaoNaoPermitida() ? ('fatura.tooltips.devolucao_nao_permitida' | translate) : 'Ctrl+D'"
                        tooltipPosition="bottom"
                        class="w-full lg:w-auto">
                        <button pButton
                            icon="pi pi-history" class="p-button-outlined w-full"
                            [disabled]="devolucaoNaoPermitida()"
                            [style.pointer-events]="devolucaoNaoPermitida() ? 'none' : 'auto'"
                            (click)="abrirDialogoDevolucao()">
                            {{ 'fatura.botoes.devolver' | translate }} (Ctrl+D)
                        </button>
                    </span>
                    <span
                        [pTooltip]="(ehTipoDeTransacaoVenda && estadoNotaEletronica.value === 'INUTILIZADA') ? ('fatura.tooltips.impressao_nao_permitida' | translate) : 'Ctrl+P'"
                        tooltipPosition="bottom"
                        class="w-full lg:w-auto">
                        <button pButton icon="pi pi-print"
                            class="p-button-outlined w-full"
                            [disabled]="ehTipoDeTransacaoVenda && estadoNotaEletronica.value === 'INUTILIZADA'"
                            [style.pointer-events]="(ehTipoDeTransacaoVenda && estadoNotaEletronica.value === 'INUTILIZADA') ? 'none' : 'auto'"
                            (click)="dialogoImpressaoVisivel=true">
                            {{ 'fatura.botoes.imprimir' | translate }} (Ctrl+P)
                        </button>
                    </span>
                    <button pButton *ngIf="ehTipoDeTransacaoVenda && deveImprimirFicha"
                        icon="pi pi-receipt" class="p-button-outlined w-full lg:w-auto"
                        [loading]="isImprimindoFicha"
                        [disabled]="isImprimindoFicha"
                        (click)="imprimirFicha()">
                        {{ 'fatura.botoes.imprimir_ficha' | translate }}
                    </button>
                    <!--
                        Cancelamento apenas no SISTEMA: nota que nunca teve NF-e valida no fisco.
                        Fica AQUI, e nao no card de NF-e: aquele bloco so renderiza para
                        tipoNota === 'ELETRONICA', justamente o caso em que este botao NAO deve
                        aparecer. Com NF-e valida o caminho e o cancelamento fiscal, que tem
                        botao proprio dentro do card.
                    -->
                    <button pButton *ngIf="podeCancelarNotaSimples()"
                        icon="pi pi-ban" class="p-button-outlined p-button-danger w-full lg:w-auto"
                        (click)="abrirDialogoCancelamento('nota')"
                        pTooltip="{{ 'fatura.tooltips.cancelar_nota' | translate }} (Alt+C)"
                        tooltipPosition="bottom">
                        {{ 'fatura.botoes.cancelar_nota' | translate }} (Alt+C)
                    </button>
                    <!--
                        HOTFIX (contexto de contador): o botao acima fica oculto quando ha
                        contexto de contador ativo (ver `podeCancelarNotaSimples`/`contextoContadorAtivo`
                        no TS) porque o backend nao honra X-Empresa-Contexto neste endpoint e a
                        acao cancelaria, em cascata, a nota da empresa ERRADA. Mostrar o motivo
                        em vez de so sumir com o botao (usuario final e leigo).
                    -->
                    <small *ngIf="cancelamentoNotaBloqueadoPorContexto" class="text-secondary">
                        {{ 'fatura-view.mensagens.cancelamento_nota_bloqueado_contexto_contador' | translate }}
                    </small>
                </div>
            </div>
        </div>

        <!-- Secao Ticket -->
        <div class="fatura-ticket-section">
            <div class="flex align-items-center justify-content-between flex-wrap gap-2">
                <div class="flex align-items-center gap-2">
                    <span class="fatura-ticket-badge">
                        <i class="pi pi-ticket mr-1"></i>
                        TICKET # {{form.codigoNota}}
                    </span>
                    <!-- ALTO-02: badge de estado da nota (EFETIVADO, DEVOLVIDO_PARCIAL, DEVOLVIDO) -->
                    <span *ngIf="form.estadoNota" class="px-2 py-1 border-round-lg text-sm font-semibold"
                        [ngClass]="{
                            'bg-green-100 text-green-700': form.estadoNota === 'EFETIVADO',
                            'bg-orange-100 text-orange-700': form.estadoNota === 'DEVOLVIDO_PARCIAL',
                            'bg-red-100 text-red-700': form.estadoNota === 'DEVOLVIDO'
                        }">
                        <i class="pi mr-1" [ngClass]="{
                            'pi-check': form.estadoNota === 'EFETIVADO',
                            'pi-replay': form.estadoNota === 'DEVOLVIDO_PARCIAL',
                            'pi-undo': form.estadoNota === 'DEVOLVIDO'
                        }"></i>
                        {{ 'enums.estado_nota.' + form.estadoNota | translate }}
                    </span>
                    <!--
                        Sem esta tag a fatura de uma nota cancelada fica identica a de uma vigente:
                        o usuario so descobre o cancelamento pela listagem.
                    -->
                    <span *ngIf="notaCancelada"
                        class="px-2 py-1 border-round-lg text-sm font-semibold bg-red-100 text-red-700">
                        <i class="pi pi-ban mr-1"></i>
                        {{ 'fatura.labels.situacao_cancelada' | translate }}
                    </span>
                </div>
                <span class="fatura-ticket-date">
                    <i class="pi pi-calendar mr-1"></i>
                    {{formatarDataEHora(form.emissaoFatura)}}
                </span>
            </div>
            <!--
                O badge "Cancelada" diz que a nota foi cancelada, mas nao diz por que.
                O motivo e obrigatorio no cancelamento, entao so faz sentido mostra-lo aqui.
            -->
            <div *ngIf="notaCancelada && form.motivoDeCancelamento" class="fatura-cancelamento-info mt-3">
                <div class="flex align-items-start gap-2">
                    <i class="pi pi-ban text-red-500 mt-1"></i>
                    <div>
                        <span class="font-medium text-red-600">
                            {{ 'fatura.labels.motivo_cancelamento' | translate }}:
                        </span>
                        <span class="text-600 ml-1">{{ form.motivoDeCancelamento }}</span>
                        <div *ngIf="form.dataDeCancelamento" class="text-600 text-sm mt-1">
                            {{ formatarDataEHora(form.dataDeCancelamento) }}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="form.ehFaturaLegal" class="fatura-legal-info mt-3" id="secao-timbrado-fatura">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-verified text-blue-500"></i>
                    <span class="font-medium text-blue-600">
                        {{ 'fatura.botoes.fatura_legal' | translate }}: {{ehTipoDeTransacaoVenda ?
                        formatarNumeroTimbradoFatura(timbradoAtual) : formatarNumeroFaturaCompra()}}
                    </span>
                    <button pButton pRipple type="button" icon="pi pi-pencil"
                        class="p-button-text p-button-sm p-button-rounded"
                        [disabled]="notaCancelada"
                        [pTooltip]="notaCancelada
                            ? ('fatura.tooltips.acao_nao_permitida_nota_cancelada' | translate)
                            : (('grupo.botoes.editar' | translate) + ' (Ctrl+E)')"
                        tooltipPosition="top"
                        (click)="dialogoEditarFaturaLegalVisivel=true">
                    </button>
                </div>
                <span class="text-600 text-sm">{{ 'fatura.placeholders.timbrado' | translate }}:
                    {{form.numeroTimbrado}}</span>
            </div>
        </div>

        <!-- Card Estado Fatura Eletronica -->
        <div *ngIf="form.tipoNota === 'ELETRONICA'" class="card-nfe-status mb-4">
            <!-- Header do Card -->
            <div class="card-nfe-header">
                <div class="flex align-items-center gap-3">
                    <div class="card-nfe-icon">
                        <i class="pi pi-file-check"></i>
                    </div>
                    <div>
                        <h3 class="m-0 text-white font-semibold text-lg">
                            {{ 'fatura.labels.estado_fatura_eletronica' | translate }}
                        </h3>
                        <span class="text-white-alpha-80 text-sm">
                            {{ form.tipoNota }}
                        </span>
                    </div>
                </div>
                <div class="card-nfe-badge" [ngClass]="{
                        'badge-pending': estadoNotaEletronica.value === 'EM_DEFINICAO',
                        'badge-success': estadoNotaEletronica.value === 'AUTORIZADA' || estadoNotaEletronica.value === 'APROVADO',
                        'badge-danger': estadoNotaEletronica.value === 'CANCELADA' || estadoNotaEletronica.value === 'INUTILIZADA',
                        'badge-warning': estadoNotaEletronica.value === 'COM_PROBLEMAS'}">
                    <i class="pi" [ngClass]="{
                        'pi-clock': estadoNotaEletronica.value === 'EM_DEFINICAO',
                        'pi-check-circle': estadoNotaEletronica.value === 'AUTORIZADA' || estadoNotaEletronica.value === 'APROVADO',
                        'pi-times-circle': estadoNotaEletronica.value === 'CANCELADA' || estadoNotaEletronica.value === 'INUTILIZADA',
                        'pi-exclamation-triangle': estadoNotaEletronica.value === 'COM_PROBLEMAS'}"></i>
                    {{ estadoNotaEletronica.label }}
                </div>
            </div>

            <!-- Corpo do Card -->
            <div class="card-nfe-body">
                <!-- Informacoes da NFe -->
                <div class="card-nfe-info-grid">
                    <div class="card-nfe-info-item">
                        <div class="info-label">
                            <i class="pi pi-hashtag text-blue-500"></i>
                            {{ 'fatura.labels.protocolo' | translate }}
                        </div>
                        <div class="info-value font-mono">{{ form.protocoloNotaEletronica || '----------' }}</div>
                    </div>
                    <div class="card-nfe-info-item">
                        <div class="info-label">
                            <i class="pi pi-calendar text-blue-500"></i>
                            {{ 'fatura.labels.emissao' | translate }}
                        </div>
                        <div class="info-value">{{ (form.dataEmissaoNotaEletronica | date:'dd/MM/yyyy HH:mm') || '--/--/-- --:--' }}</div>
                    </div>
                    <div class="card-nfe-info-item col-span-2">
                        <div class="info-label">
                            <i class="pi pi-info-circle text-blue-500"></i>
                            {{ 'fatura.labels.mensagem' | translate }}
                        </div>
                        <div class="info-value">{{ form.mensagemSief || '----------' }}</div>
                    </div>
                    <!-- Aviso de expiracao do periodo de cancelamento (72h) -->
                    <div *ngIf="periodoCancelamentoExpirou()" class="card-nfe-info-item col-span-2">
                        <div class="nfe-aviso-expiracao">
                            <i class="pi pi-exclamation-triangle"></i>
                            <span>{{ 'fatura.labels.periodo_cancelamento_expirado' | translate }}</span>
                        </div>
                    </div>
                </div>

                <!-- Acoes Rapidas -->
                <div class="card-nfe-quick-actions">
                    <button pButton pRipple type="button" icon="pi pi-chart-line"
                        class="p-button-text p-button-sm"
                        [disabled]="estadoNotaEletronica.value === 'EM_DEFINICAO'"
                        (click)="buscarEventoEnvioNfe()"
                        pTooltip="Ctrl+H" tooltipPosition="bottom">
                        {{ 'fatura.botoes.historico_eventos' | translate }} (Ctrl+H)
                    </button>
                    <span
                        [pTooltip]="(ehTipoDeTransacaoVenda && estadoNotaEletronica.value === 'INUTILIZADA') ? ('fatura.tooltips.impressao_nao_permitida' | translate) : 'Ctrl+Shift+P'"
                        tooltipPosition="bottom"
                        class="inline-block">
                        <button pButton pRipple type="button" icon="pi pi-print"
                            [disabled]="(estadoNotaEletronica.value != 'AUTORIZADA' && estadoNotaEletronica.value != 'APROVADO') || isImprimindoNfe"
                            [loading]="isImprimindoNfe"
                            class="p-button-text p-button-sm text-blue-600"
                            [style.pointer-events]="(ehTipoDeTransacaoVenda && estadoNotaEletronica.value === 'INUTILIZADA') ? 'none' : 'auto'"
                            (click)="abrirDialogoImpressaoNfe()">
                            {{ 'fatura.botoes.imprimir' | translate }} (Ctrl+Shift+P)
                        </button>
                    </span>
                    <span
                        [pTooltip]="!podeConsultarNaSifen() ? ('fatura.tooltips.consulta_sifen_nao_disponivel' | translate) : 'Ctrl+Shift+C'"
                        tooltipPosition="bottom"
                        class="inline-block">
                        <button pButton pRipple type="button" icon="pi pi-external-link"
                            class="p-button-text p-button-sm text-blue-600"
                            [disabled]="!podeConsultarNaSifen()"
                            [style.pointer-events]="!podeConsultarNaSifen() ? 'none' : 'auto'"
                            (click)="abrirUrlConsulta()">
                            {{ 'fatura.botoes.consultar_na_sifen' | translate }} (Ctrl+Shift+C)
                        </button>
                    </span>
                </div>

                <!-- Botoes de Acao -->
                <div class="card-nfe-actions">
                    <button *ngIf="estadoNfeCarregado && !notaCancelada && estadoNotaEletronica.value === 'EM_DEFINICAO'" pButton
                        (click)="abrirDialogoConfirmarTransmissao()"
                        class="px-5 py-2 font-semibold border-round-lg shadow-2"
                        pTooltip="Alt+T" tooltipPosition="bottom">
                        {{ 'fatura.botoes.transmitir' | translate }} (Alt+T)
                    </button>

                    <!-- MEDIO-04: comparacao direta com enum ao inves de .includes() fragil -->
                    <button
                        *ngIf="estadoNotaEletronica.value === 'AUTORIZADA' || estadoNotaEletronica.value === 'CANCELADA' || estadoNotaEletronica.value === 'APROVADO'"
                        pButton severity="success"
                        (click)="consultarNfeComDialogo()"
                        class="px-5 py-2 font-semibold border-round-lg shadow-2"
                        pTooltip="Alt+Q" tooltipPosition="bottom">
                        {{ 'fatura.botoes.consultar' | translate }} (Alt+Q)
                    </button>

                    <!-- Cancelamento FISCAL: nota com NF-e valida no fisco, dentro das 72h -->
                    <button *ngIf="podeCancelarNfe() && podeCancelarNotaPermissao" pButton severity="danger"
                        (click)="abrirDialogoCancelamento('nfe')"
                        class="px-5 py-2 font-semibold border-round-lg shadow-2"
                        pTooltip="Alt+C" tooltipPosition="bottom">
                        {{ 'fatura.botoes.cancelar' | translate }} (Alt+C)
                    </button>

                    <!-- MEDIO-08: estado COM_PROBLEMAS - acao primaria: tentar novamente; secundaria: inutilizar -->
                    <!-- Retransmitir aparece primeiro com destaque visual (acao primaria recomendada) -->
                    <button *ngIf="estadoNfeCarregado && !notaCancelada && estadoNotaEletronica.value === 'COM_PROBLEMAS'" pButton
                        icon="pi pi-send"
                        (click)="abrirDialogoConfirmarTransmissao()"
                        class="px-5 py-2 font-semibold border-round-lg shadow-2"
                        pTooltip="{{ 'fatura.tooltips.retransmitir_hint' | translate }} (Alt+T)"
                        tooltipPosition="bottom">
                        {{ 'fatura.botoes.tentar_novamente' | translate }} (Alt+T)
                    </button>
                    <!-- Inutilizar aparece como acao secundaria (menos destaque) -->
                    <button *ngIf="estadoNotaEletronica.value === 'COM_PROBLEMAS' && !notaCancelada" pButton severity="secondary"
                        icon="pi pi-ban"
                        (click)="dialogoMotivoInutilizacaoVisivel = true"
                        class="px-5 py-2 font-semibold border-round-lg shadow-2"
                        pTooltip="{{ 'fatura.tooltips.inutilizar_hint' | translate }} (Alt+I)"
                        tooltipPosition="bottom">
                        {{ 'fatura.botoes.inutilizar_numeracao' | translate }} (Alt+I)
                    </button>
                </div>
            </div>
        </div>

        <!-- Tabela de Itens da Nota -->
        <div class="fatura-table-container" id="secao-itens-nota">
            <div class="fatura-table-header-label">
                <i class="pi pi-list mr-2"></i>
                {{ 'fatura.labels.informacao_do_item' | translate }}
            </div>
            <div class="overflow-x-auto">
                <table class="fatura-table w-full">
                    <thead>
                        <tr>
                            <th class="text-left white-space-nowrap">
                                {{ 'fatura.labels.sl' | translate }}</th>
                            <th class="text-left white-space-nowrap">
                                {{ 'fatura.labels.imagem' | translate }}</th>
                            <th class="text-left white-space-nowrap">
                                {{ 'fatura.labels.informacao_do_item' | translate }}</th>
                            <th class="text-right white-space-nowrap">
                                {{ 'fatura.labels.quantidade' | translate }}</th>
                            <th class="text-right white-space-nowrap">
                                {{ 'fatura.labels.preco' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of form.itemDeNota; let i = index">
                            <ng-container *ngIf="itensDeNota[i]">
                                <td class="text-left white-space-nowrap">
                                    <span class="fatura-item-index">{{ i + 1 }}</span>
                                </td>
                                <td class="text-left white-space-nowrap">
                                    <img class="product-image"
                                        [src]="itensDeNota[i].imagem ? (env.imgHost + '/' + idEmpresa + '/item/' + itensDeNota[i].imagem) : 'assets/images/profile_placeholder.png'"
                                        [alt]="itensDeNota[i].nome" (error)="onImageError($event)" />
                                </td>
                                <td class="text-left">
                                    <span class="font-medium text-900">{{ itensDeNota[i].nome }}</span>
                                    <!-- Observacao do item (digitada na venda/pedido) -->
                                    <div *ngIf="observacaoVisivelDoItem(item, itensDeNota[i].nome) as obs" class="fatura-item-obs mt-1">
                                        <i class="pi pi-comment mr-1"></i>
                                        <span>{{ obs }}</span>
                                    </div>
                                    <!-- Variantes de Preco -->
                                    <div *ngIf="item.variantesDePreco?.length" class="fatura-sub-itens mt-1">
                                        <div *ngFor="let variante of item.variantesDePreco" class="fatura-sub-item">
                                            <i class="pi pi-tag text-blue-500 mr-1"></i>
                                            <span>{{ variante.descricao || variante.codigoDaVariante }}<ng-container *ngIf="quantidadePorUnidade(variante.quantidade, item.quantidade) > 1"> (x{{ quantidadePorUnidade(variante.quantidade, item.quantidade) }})</ng-container>: {{ formatarValorMonetario(variante.precoDeVenda || 0, form.moeda) }}</span>
                                        </div>
                                    </div>
                                    <!-- Modificadores -->
                                    <div *ngIf="item.modificadores?.length" class="fatura-sub-itens mt-1">
                                        <div *ngFor="let mod of item.modificadores" class="fatura-sub-item">
                                            <i class="pi pi-plus-circle text-green-500 mr-1"></i>
                                            <span>{{ mod.descricao || mod.codigoDoModificador }}<ng-container *ngIf="quantidadePorUnidade(mod.quantidade, item.quantidade) > 1"> (x{{ quantidadePorUnidade(mod.quantidade, item.quantidade) }})</ng-container>: {{ formatarValorMonetario(mod.precoDeVenda || 0, form.moeda) }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-right">
                                    <span class="font-medium">{{ item.quantidade }}</span>
                                    <div *ngIf="quantidadeDevolvida(item.item_id || itensDeNota[i].id) > 0"
                                         class="text-xs mt-1"
                                         [ngClass]="{
                                            'text-orange-600': saldoDisponivel(item, i) > 0,
                                            'text-red-600': saldoDisponivel(item, i) === 0
                                         }">
                                        <i class="pi pi-replay text-xs mr-1"></i>
                                        {{ 'fatura.labels.devolvido' | translate }}: {{ quantidadeDevolvida(item.item_id || itensDeNota[i].id) }}
                                        <span *ngIf="saldoDisponivel(item, i) > 0">
                                            ({{ 'fatura.labels.saldo' | translate }}: {{ saldoDisponivel(item, i) }})
                                        </span>
                                        <span *ngIf="saldoDisponivel(item, i) === 0" class="font-semibold">
                                            ({{ 'fatura.labels.totalmente_devolvido' | translate }})
                                        </span>
                                    </div>
                                </td>
                                <td class="text-right">
                                    <span class="font-semibold text-900">{{ formatarValorMonetario(item.valorTotal, form.moeda) }}</span>
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Resumo Financeiro -->
        <div class="fatura-resumo-section mt-4">
            <!-- Subtotal e Descontos -->
            <div class="fatura-resumo-card">
                <div class="flex justify-content-between align-items-center mb-3">
                    <span class="text-600">{{ 'fatura.labels.subtotal' | translate }}</span>
                    <span class="font-medium text-900">{{ formatarValorMonetario(form.valorTotal, form.moeda)}}</span>
                </div>
                <div class="flex justify-content-between align-items-center">
                    <span class="text-600">{{ 'fatura.labels.descontos_dos_itens' | translate }}</span>
                    <span class="font-medium text-red-500">- {{formatarValorMonetario(form.valorDoDesconto, form.moeda)}}</span>
                </div>
            </div>

            <!-- Metodo de Pagamento -->
            <div class="fatura-pagamento-card mt-3">
                <div class="fatura-pagamento-header">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-wallet text-blue-500"></i>
                        <span class="font-semibold text-900">{{ 'fatura.labels.metodo_de_pagamento' | translate }}</span>
                    </div>
                    <span class="fatura-parcela-badge fatura-parcela-badge--cash">
                        {{ metodoPagamentoBadgeKey | translate }}
                    </span>
                </div>

                <div *ngIf="form.numeroParcelas" class="mt-3">
                    <!--
                        Cada parcela mostra vencimento, situacao e - quando ja recebeu pagamento -
                        a data em que foi paga: sem isso o usuario nao sabe quais parcelas ja
                        foram quitadas nem quando.
                    -->
                    <div *ngFor="let item of form.titulos; let i = index"
                        class="fatura-parcela-item"
                        [class.fatura-parcela-item--clicavel]="podeAbrirTitulosDaPessoa"
                        [attr.role]="podeAbrirTitulosDaPessoa ? 'button' : null"
                        [attr.tabindex]="podeAbrirTitulosDaPessoa ? 0 : null"
                        [pTooltip]="podeAbrirTitulosDaPessoa ? ('fatura.tooltips.ver_titulos_da_pessoa' | translate) : ''"
                        tooltipPosition="top"
                        (click)="abrirTitulosDaPessoa()"
                        (keydown.enter)="abrirTitulosDaPessoa()">
                        <div class="flex align-items-center gap-2">
                            <span class="fatura-parcela-numero">{{ i + 1 }}</span>
                            <div class="flex flex-column">
                                <span class="text-700">{{ formatarData(item.vencimento) }}</span>
                                <!--
                                    Uma parcela pode ser quitada em varios pagamentos: listamos todos
                                    (data + valor), como na tela de contas a receber.
                                -->
                                <div *ngIf="pagamentosDoTitulo(item).length > 0" class="fatura-parcela-pagamentos">
                                    <span class="fatura-parcela-pagamentos-titulo">
                                        {{ 'fatura.labels.pagamentos_da_parcela' | translate }}
                                    </span>
                                    <div *ngFor="let pagamento of pagamentosDoTitulo(item)"
                                        class="fatura-parcela-pagamento">
                                        <i class="pi pi-check-circle mr-1"></i>
                                        <span>{{ pagamento.emissaoMovimento ? formatarData(pagamento.emissaoMovimento) : '-' }}</span>
                                        <span class="fatura-parcela-pagamento-valor">
                                            {{ formatarValorMonetario(valorDoPagamento(pagamento), item.moeda) }}
                                        </span>
                                    </div>
                                    <span *ngIf="pagamentosDoTitulo(item).length > 1"
                                        class="fatura-parcela-pagamento-total">
                                        {{ 'fatura.labels.total_pago_parcela' | translate }}:
                                        {{ formatarValorMonetario(totalPagoTitulo(item), item.moeda) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <span class="fatura-parcela-situacao"
                                [ngClass]="{
                                    'fatura-parcela-situacao--pago': tituloPago(item),
                                    'fatura-parcela-situacao--cancelado': tituloCancelado(item)
                                }">
                                {{ situacaoTituloBadgeKey(item) | translate }}
                            </span>
                            <span class="font-semibold text-900">{{ formatarValorMonetario(item.valor, item.moeda) }}</span>
                            <i *ngIf="podeAbrirTitulosDaPessoa" class="pi pi-chevron-right text-500 text-sm"></i>
                        </div>
                    </div>
                </div>
                <div *ngIf="!form.numeroParcelas" class="mt-3">
                    <!--
                        Pagamento em conta (refatorado em 2026-05):
                        O backend passou a gravar a Baixa com `moeda = moedaDaConta` e
                        `valor = valorRecebidoNaConta` direto, deixando os campos
                        `valorRecebidoEm{Moeda}` zerados quando a venda é paga em conta.
                        Por isso, quando há conta, exibimos UMA única linha com o rótulo
                        da moeda da conta + nome da conta + valor já formatado na moeda
                        da conta. As linhas de efetivo por moeda só aparecem quando NÃO
                        há conta (pagamento em dinheiro).
                    -->
                    <div *ngIf="(form.conta_id ?? 0) > 0 && form.valorRecebidoNaConta > 0" class="fatura-moeda-item">
                        <span class="text-600">
                            {{ getMoedaLabel(form.moedaDaConta) | translate }}
                            <span *ngIf="form.nomeConta" class="text-500"> — {{ form.nomeConta }}</span>
                        </span>
                        <span class="font-medium text-900">{{ formatarValorMonetario(form.valorRecebidoNaConta, form.moedaDaConta) }}</span>
                    </div>
                    <ng-container *ngIf="!((form.conta_id ?? 0) > 0)">
                        <div *ngIf="moedasVisiveis.has(moedaDolar) && form.valorRecebidoEmDolar !== 0" class="fatura-moeda-item">
                            <span class="text-600">
                                {{ 'fatura.labels.dolar' | translate }}
                            </span>
                            <span class="flex align-items-center gap-2">
                                <p-tag *ngIf="form.valorRecebidoEmDolar < 0"
                                       severity="info"
                                       [value]="'fatura.labels.troco' | translate"></p-tag>
                                <span class="font-medium text-900">{{ formatarValorMonetario(absValor(form.valorRecebidoEmDolar), moedaDolar) }}</span>
                            </span>
                        </div>
                        <div *ngIf="moedasVisiveis.has(moedaGuarani) && form.valorRecebidoEmGuarani !== 0" class="fatura-moeda-item">
                            <span class="text-600">
                                {{ 'fatura.labels.guarani' | translate }}
                            </span>
                            <span class="flex align-items-center gap-2">
                                <p-tag *ngIf="form.valorRecebidoEmGuarani < 0"
                                       severity="info"
                                       [value]="'fatura.labels.troco' | translate"></p-tag>
                                <span class="font-medium text-900">{{ formatarValorMonetario(absValor(form.valorRecebidoEmGuarani), moedaGuarani) }}</span>
                            </span>
                        </div>
                        <div *ngIf="moedasVisiveis.has(moedaReal) && form.valorRecebidoEmReal !== 0" class="fatura-moeda-item">
                            <span class="text-600">
                                {{ 'fatura.labels.real' | translate }}
                            </span>
                            <span class="flex align-items-center gap-2">
                                <p-tag *ngIf="form.valorRecebidoEmReal < 0"
                                       severity="info"
                                       [value]="'fatura.labels.troco' | translate"></p-tag>
                                <span class="font-medium text-900">{{ formatarValorMonetario(absValor(form.valorRecebidoEmReal), moedaReal) }}</span>
                            </span>
                        </div>
                        <div *ngIf="moedasVisiveis.has(moedaPeso) && (form.valorRecebidoEmPeso ?? 0) !== 0" class="fatura-moeda-item">
                            <span class="text-600">
                                {{ 'fatura.labels.peso' | translate }}
                            </span>
                            <span class="flex align-items-center gap-2">
                                <p-tag *ngIf="(form.valorRecebidoEmPeso ?? 0) < 0"
                                       severity="info"
                                       [value]="'fatura.labels.troco' | translate"></p-tag>
                                <span class="font-medium text-900">{{ formatarValorMonetario(absValor(form.valorRecebidoEmPeso), moedaPeso) }}</span>
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- Total -->
            <div class="fatura-total-card mt-3">
                <div class="flex justify-content-between align-items-center">
                    <span class="fatura-total-label">{{ 'fatura.labels.total' | translate }}</span>
                    <span class="fatura-total-valor">{{formatarValorMonetario(form.valorTotalComDesconto, form.moeda)}}</span>
                </div>
            </div>

            <!-- Observacao -->
            <div *ngIf="form.observacao" class="fatura-observacao-card mt-3">
                <div class="flex align-items-start gap-2">
                    <i class="pi pi-comment text-500 mt-1"></i>
                    <div>
                        <span class="text-600 text-sm font-semibold block mb-1">{{ 'fatura.labels.observacao' | translate }}</span>
                        <span class="text-800">{{form.observacao}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Termos e Condicoes -->
        <div class="fatura-termos-section">
            <h4 class="m-0 text-600 text-sm font-semibold">{{ 'fatura.texts.termos_e_condicoes' | translate }}</h4>
            <p class="mt-1 mb-0 text-500 text-xs line-height-3">
                {{ 'fatura.texts.descricao_termos_e_condicoes' | translate }}
            </p>
        </div>

        <!-- Botao Voltar -->
        <div class="fatura-footer-actions">
            <button pButton (click)="navigateListaDeNotas()"
                icon="pi pi-arrow-left" class="p-button-secondary"
                pTooltip="Esc" tooltipPosition="bottom">
                {{ 'add-cliente.botoes.voltar' | translate }} (Esc)
            </button>
        </div>
    </div>
</div>

<p-toast></p-toast>

<!-- DIALOGO FATURA LEGAL -->
<p-dialog
    [(visible)]="dialogoFaturaLegalVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '35rem', height: 'auto' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-file-edit" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.fatura_legal' | translate }}</h2>
                <p>{{ 'fatura.texts.selecione_timbrado' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <div *ngIf="ehTipoDeTransacaoVenda || ehTipoDeTransacaoDevolucao" class="field">
            <label>{{ 'fatura.placeholders.timbrado' | translate }}</label>
            <p-dropdown [options]="timbradosVendaList" [(ngModel)]="selectedTimbrado" optionLabel="tipoNota" [filter]="true"
                required="true" filterBy="tipoNota" [showClear]="true"
                placeholder="{{ 'fatura.placeholders.timbrado' | translate }}"
                [emptyMessage]="'fatura.texts.lista_vazia' | translate" class="w-full"
                appendTo="body" panelStyleClass="dropdown-panel-above-modal">
                <ng-template #selectedItem let-selectedOption>
                    <div class="flex items-center gap-2">
                        <div>{{ selectedOption?.nomeTipoNota }} - {{formatarNumeroTimbrado(selectedOption)}}</div>
                    </div>
                </ng-template>
                <ng-template let-item pTemplate="item">
                    <div class="flex items-center justify-center align-items-center gap-2">
                        <div>{{ item.nomeTipoNota }}</div>
                        <small class="text-gray-500">{{formatarNumeroTimbrado(item)}}</small>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>

        <div *ngIf="ehTipoDeTransacaoCompra || ehTipoDeTransacaoDevolucaoDeCompra" class="grid">
            <div class="field col-3 p-0 pr-2">
                <label>{{ 'fatura.labels.filial' | translate }}</label>
                <input type="text" pInputText placeholder="000" [zeroMask]="3"
                    [(ngModel)]="novoDadosNotaEmFaturaCompra.numeroFilial" />
            </div>
            <div class="field col-4 p-0 pr-2">
                <label>{{ 'fatura.labels.ponto_expedicao' | translate }}</label>
                <input type="text" pInputText placeholder="000" [zeroMask]="3"
                    [(ngModel)]="novoDadosNotaEmFaturaCompra.pontoDeExpedicao" />
            </div>
            <div class="field col-5 p-0">
                <label>{{ 'fatura.labels.numero' | translate }}</label>
                <input type="text" pInputText placeholder="0000000" [zeroMask]="7"
                    [(ngModel)]="novoDadosNotaEmFaturaCompra.proximoNumero" />
            </div>
        </div>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoFaturaLegalVisivel=false">
            {{ 'fatura.botoes.cancelar' | translate }} (Esc)
        </button>
        <button pButton icon="pi pi-save"
            (click)="transformaNotaEmFatura()">
            {{ 'fatura.botoes.salvar' | translate }} (Enter)
        </button>
    </ng-template>
</p-dialog>

<!-- DIALOGO EDITAR FATURA LEGAL -->
<p-dialog
    [(visible)]="dialogoEditarFaturaLegalVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '30rem', height: 'auto' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-pencil" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.editar_numero_fatura' | translate }}</h2>
                <p>{{ 'fatura.texts.altere_numero_fatura' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <div class="field">
            <label>{{ 'fatura.dialogos.numero_da_fatura' | translate }} <span class="text-red-500">*</span></label>
            <input class="w-full" type="text" pInputText placeholder="0000000" [zeroMask]="7"
                [(ngModel)]="numeroFaturaNovo" />
        </div>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoEditarFaturaLegalVisivel=false">
            {{ 'fatura.botoes.cancelar' | translate }} (Esc)
        </button>
        <button pButton
            (click)="atualizarTimbrado()">
            {{ 'fatura.botoes.aplicar' | translate }} (Enter)
        </button>
    </ng-template>
</p-dialog>

<!-- DIALOGO DEVOLUCAO DE VENDA ETAPA 1 -->
<p-dialog
    [(visible)]="dialogoDevolverEtapa1Visivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign dialog-devolucao-redesign"
    [style]="{ width: '50rem' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-history" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.devolucao_de_venda' | translate }}</h2>
                <p>{{ 'fatura.texts.selecione_itens_devolucao' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body dialog-devolucao-body">
        <div *ngIf="ehTipoDeTransacaoCompra || ehTipoDeTransacaoDevolucaoDeCompra || (ehTipoDeTransacaoVenda && form.ehFaturaLegal)" class="field mb-4">
            <label>{{ 'fatura.placeholders.timbrado' | translate }}</label>
            <p-dropdown [options]="timbradosDevolucaoList" [(ngModel)]="selectedTimbrado" optionLabel="tipoNota"
                [filter]="true" required="true" filterBy="tipoNota" [showClear]="true"
                placeholder="{{ 'fatura.placeholders.timbrado' | translate }}"
                [emptyMessage]="'fatura.texts.lista_vazia' | translate" class="w-full"
                appendTo="body" panelStyleClass="dropdown-panel-above-modal">
                <ng-template #selectedItem let-selectedOption>
                    <div class="flex items-center gap-2">
                        <div>{{ selectedOption?.tipoNota }} - {{formatarNumeroTimbrado(selectedOption)}}</div>
                    </div>
                </ng-template>
                <ng-template let-item pTemplate="item">
                    <div class="flex items-center gap-2">
                        <div>{{ item.tipoNota }}</div>
                        <small class="text-gray-500">{{formatarNumeroTimbrado(item)}}</small>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>

        <div class="dialog-devolucao-lista">
            <p-dataView #dv [value]="itensDeNotaDevolucao" [rows]="5" [paginator]="itensDeNotaDevolucao.length > 5">
                <ng-template pTemplate="list" let-products>
                    <div class="grid grid-nogutter produto-data-view-list">
                        <div class="col-12" *ngFor="let item of products; let i = index;">
                            <div class="flex flex-column sm:flex-row sm:align-items-center p-3">
                                <div class="md:w-10rem relative">
                                    <img class="block xl:block mx-auto border-round w-full product-image-dialog"
                                        [src]="env.imgHost + '/' + idEmpresa + '/item/' + item?.imagem" [alt]="item?.nome"
                                        (error)="onImageError($event)" />
                                </div>
                                <div class="flex flex-column flex-row justify-content-between align-items-center flex-1 gap-4">
                                    <div class="flex flex-row flex-column justify-content-between align-items-start gap-2">
                                        <div>
                                            <div class="text-lg font-medium text-900 mt-2">{{ item.nome }}</div>
                                            <span class="font-medium text-secondary text-sm">{{
                                                formatarValorMonetario(calcularValorUnitarioItemDevolucaoComDesconto(item),
                                                form.moeda) }}</span>
                                        </div>
                                        <div>
                                            <span class="font-semibold text-secondary text-sm text-green-500">{{
                                                formatarValorMonetario((calcularValorUnitarioItemDevolucaoComDesconto(item) *
                                                item.quantidade), form.moeda) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p-inputNumber class="w-10rem mt-7" [(ngModel)]="item.quantidade" [showButtons]="true"
                                        [min]="0" [max]="item.quantidadeMaxima" buttonLayout="horizontal" spinnerMode="vertical"
                                        decrementButtonClass="p-button-secondary" incrementButtonClass="p-button-secondary"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" />
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView>
        </div>

        <!-- Total sempre visivel, fora do dataview -->
        <p-divider layout="horizontal" />
        <div class="flex flex-row justify-content-between align-items-center gap-2 mt-2 mb-2">
            <div class="font-semibold text-900 text-lg">{{ 'fatura.labels.total' | translate }}</div>
            <span class="font-bold text-900 text-xl">{{
                formatarValorMonetario(calcularValorTotalItensDeNotaDevolucao(), form.moeda) }}</span>
        </div>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoDevolverEtapa1Visivel=false">
            {{ 'fatura.botoes.cancelar' | translate }} (Esc)
        </button>
        <button pButton
            icon="pi pi-history" (click)="devolver()">
            {{ 'fatura.botoes.devolver' | translate }} (Enter)
        </button>
    </ng-template>
</p-dialog>

<!-- Dialog Forma de Pagamento - Devolucao (Etapa 2) -->
<app-forma-pagamento-dialog
  [(visible)]="mostrarDialogPagamentoDevolucao"
  [totalAPagar]="calcularValorTotalItensDeNotaDevolucao()"
  [config]="{
    formasPermitidas: ['dinheiro', 'conta'],
    moedaPadrao: moedaPadraoISO,
    habilitarMultiMoeda: true,
    cotacoes: { cotUSD: cotUSD, cotPYG: cotPYG, cotBRL: cotBRL, cotRealGuarani: cotRealGuarani, cotPesoGuarani: cotPesoGuarani },
    tituloHeader: ('fatura.dialogos.forma_devolucao' | translate),
    subtituloHeader: ('fatura.texts.selecione_forma_devolucao' | translate),
    labelBotaoConfirmar: ('fatura.botoes.devolver' | translate),
    iconeBotaoConfirmar: 'pi pi-history'
  }"
  [contas]="contasFormatadas"
  [moedaNota]="moedaNotaEnum"
  [processando]="processandoDevolucao"
  (confirmar)="onDevolucaoConfirmada($event)"
  (cancelar)="mostrarDialogPagamentoDevolucao = false">
</app-forma-pagamento-dialog>

<!-- DIALOGO IMPRIMIR OU COMPARTILHAR -->
<p-dialog
    [(visible)]="dialogoImpressaoVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '42rem', height: 'auto' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-print" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.imprimir_ou_compartilhar' | translate }}</h2>
                <p>{{ 'fatura.texts.selecione_formato_impressao' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <form [formGroup]="tipoDeImpressaoForm">
            <div class="field">
                <label class="mb-3">{{ 'fatura.labels.formato_impressao' | translate }}</label>
                <div class="flex flex-column gap-3">
                    <div class="flex items-center">
                        <p-radioButton name="impressao" value="A4" formControlName="impressao"
                            inputId="impressaoA4"></p-radioButton>
                        <label for="impressaoA4" class="ml-2 font-normal">A4</label>
                    </div>
                    <div class="flex items-center">
                        <p-radioButton name="impressao" value="BOBINA_58" formControlName="impressao"
                            inputId="impressao58"></p-radioButton>
                        <label for="impressao58" class="ml-2 font-normal">{{ 'fatura.labels.bobina_58mm' | translate }}</label>
                    </div>
                    <div class="flex items-center">
                        <p-radioButton name="impressao" value="BOBINA_80" formControlName="impressao"
                            inputId="impressao80"></p-radioButton>
                        <label for="impressao80" class="ml-2 font-normal">{{ 'fatura.labels.bobina_80mm' | translate }}</label>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoImpressaoVisivel=false">
            {{ 'fatura.botoes.cancelar' | translate }} (Esc)
        </button>
        <button pButton icon="pi pi-print"
            [loading]="isImprimindoFatura" (click)="imprimir()">
            {{ 'fatura.botoes.imprimir' | translate }} (Enter)
        </button>
        <button pButton icon="pi pi-download" severity="success"
            [loading]="isImprimindoFatura" (click)="downloadPDF()"
            pTooltip="Ctrl+Shift+D" tooltipPosition="bottom">
            {{ 'fatura.botoes.baixar' | translate }} (Ctrl+Shift+D)
        </button>
    </ng-template>
</p-dialog>

<!-- DIALOGO CONSULTA FATURA ELETRONICA -->
<p-dialog
    [(visible)]="dialogoDetalhesFaturaVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '45rem', height: 'auto' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-file-check" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.detalhes_fatura_eletronica' | translate }}</h2>
                <p>{{ 'fatura.texts.informacoes_nota_fiscal' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <div *ngIf="faturaEletronica" class="grid grid-nogutter">
            <div class="col-12 mb-4 flex justify-content-between align-items-center bg-blue-50 p-3 border-round">
                <span class="text-700 font-semibold">{{ 'fatura.labels.estado_atual' | translate }}</span>
                <span
                    [class]="'font-bold text-lg ' + (faturaEletronica.descMensagem === 'CANCELADO' ? 'text-red-500' : 'text-green-500')">
                    {{ faturaEletronica.descMensagem }}
                </span>
            </div>

            <div class="col-12 md:col-6 py-2 border-bottom-1 surface-border">
                <label class="text-500 text-sm block">{{ 'fatura.labels.protocolo' | translate }}</label>
                <span class="text-900 font-medium">{{ faturaEletronica.numeroDoProtocolo || '---' }}</span>
            </div>
            <div class="col-12 md:col-6 py-2 border-bottom-1 surface-border">
                <label class="text-500 text-sm block">{{ 'fatura.labels.cdc' | translate }}</label>
                <span class="text-900 font-medium text-xs">{{ faturaEletronica.numeroCDC || '---' }}</span>
            </div>

            <div class="col-12 md:col-6 py-2 border-bottom-1 surface-border">
                <label class="text-500 text-sm block">{{ 'fatura.labels.lote' | translate }}</label>
                <span class="text-900 font-medium">{{ faturaEletronica.lote || '---' }}</span>
            </div>
            <div class="col-12 md:col-6 py-2 border-bottom-1 surface-border">
                <label class="text-500 text-sm block">{{ 'fatura.labels.emissao' | translate }}</label>
                <span class="text-900 font-medium">{{ (faturaEletronica.emissao | date:'dd/MM/yyyy HH:mm:ss') || '---' }}</span>
            </div>

            <div class="col-12 py-2 border-bottom-1 surface-border">
                <label class="text-500 text-sm block">{{ 'fatura.labels.url_consulta' | translate }}</label>
                <div class="flex overflow-hidden">
                    <a [href]="faturaEletronica.urlNFe" target="_blank"
                        class="text-blue-500 text-xs no-underline hover:underline line-height-2 w-full"
                        style="word-break: break-all; white-space: normal;">
                        {{ faturaEletronica.urlNFe }}
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoDetalhesFaturaVisivel=false">
            {{ 'fatura.botoes.fechar' | translate }} (Esc)
        </button>
        <button pButton icon="pi pi-external-link"
            (click)="abrirUrlConsulta()"
            pTooltip="Ctrl+U" tooltipPosition="bottom">
            {{ 'fatura.botoes.consultar_url' | translate }} (Ctrl+U)
        </button>
    </ng-template>
</p-dialog>


<p-dialog
    [(visible)]="dialogoHistoricoEventosVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '70vw', height: 'auto' }"
    [breakpoints]="{'960px': '95vw'}">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-chart-line" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.historico_eventos' | translate }}</h2>
                <p>{{ 'fatura.texts.historico_transmissoes' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <p-table [value]="historicoEventosEnvioNfe" [paginator]="true" [rows]="10" [responsiveLayout]="'scroll'"
            styleClass="p-datatable-sm p-datatable-striped" [sortField]="'emissao'">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="emissao" style="width: 25%">
                        {{ 'fatura.labels.data_hora' | translate }}
                        <p-sortIcon field="emissao"></p-sortIcon>
                    </th>
                    <th style="width: 20%">{{ 'fatura.labels.evento' | translate }}</th>
                    <th style="width: 15%">{{ 'fatura.labels.protocolo' | translate }}</th>
                    <th style="width: 25%">{{ 'fatura.labels.mensagem' | translate }}</th>
                    <th style="width: 15%" class="text-center">{{ 'fatura.labels.status' | translate }}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-evento>
                <tr class="text-sm">
                    <td>{{ evento.emissao | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td>
                        <span class="font-semibold text-blue-600">
                            {{ evento.tipoEvento?.nome || evento.tipoEvento }}
                        </span>
                    </td>
                    <td class="font-monospace text-xs">{{ evento.numeroDoProtocolo || '---' }}</td>
                    <td>
                        <div class="white-space-normal line-height-2" style="word-break: break-word;">
                            {{ evento.list?.length > 0 ? evento.list[0].descMensagem : evento.descMensagem }}
                        </div>
                    </td>
                    <td class="text-center">
                        <span [class]="'p-tag ' + (evento.descMensagem === 'APROVADO' ? 'p-tag-success' : 'p-tag-danger')">
                            {{ evento.descMensagem }}
                        </span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoHistoricoEventosVisivel=false">
            {{ 'fatura.botoes.fechar' | translate }} (Esc)
        </button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="dialogoMotivoCancelamentoVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '30rem', height: 'auto' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-times-circle" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>
                    {{ (tipoCancelamentoSolicitado === 'nota'
                        ? 'fatura.dialogos.cancelar_nota'
                        : 'fatura.dialogos.cancelar_fatura_eletronica') | translate }}
                </h2>
                <p>
                    {{ (tipoCancelamentoSolicitado === 'nota'
                        ? 'fatura.texts.informe_motivo_cancelamento_nota'
                        : 'fatura.texts.informe_motivo_cancelamento') | translate }}
                </p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <div class="field">
            <label for="motivo">{{ 'fatura.labels.motivo_cancelamento' | translate }}</label>
            <textarea id="motivo" pInputTextarea [(ngModel)]="motivoCancelamentoNfe" rows="4"
                placeholder="{{ 'fatura.placeholders.digite_motivo_cancelamento' | translate }}" class="w-full">
            </textarea>
            <small class="text-secondary">{{ 'fatura.labels.minimo_caracteres' | translate: { min: 5 } }}</small>
        </div>

        <!--
            Aviso de estorno: so aparece quando a nota tem parcela paga. Cancelar aqui devolve
            dinheiro que ja entrou no caixa, entao o usuario ve o que sera desfeito e precisa
            aceitar explicitamente antes de o botao liberar.
        -->
        <div class="field mt-3" *ngIf="exigeConfirmacaoDeEstorno">
            <div class="p-3 border-round surface-100">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-exclamation-triangle text-orange-500" aria-hidden="true"></i>
                    <strong>{{ 'fatura.dialogos.estorno_titulo' | translate }}</strong>
                </div>

                <p class="mb-2">
                    {{ 'fatura.texts.estorno_aviso' | translate: {
                        valor: resumoCancelamento!.valorTotalEstornado | number: '1.0-2'
                    } }}
                </p>

                <ul class="m-0 pl-3">
                    <li *ngFor="let titulo of resumoCancelamento!.titulos">
                        {{ 'fatura.texts.estorno_parcela' | translate: {
                            parcela: titulo.numeroParcela,
                            valor: titulo.valorPago | number: '1.0-2'
                        } }}
                    </li>
                    <li *ngFor="let movimento of resumoCancelamento!.movimentos">
                        <ng-container *ngIf="movimento.seraCancelado; else movimentoReduzido">
                            {{ 'fatura.texts.estorno_movimento_cancelado' | translate: {
                                codigo: movimento.codigoMovimento,
                                valor: movimento.valor | number: '1.0-2'
                            } }}
                        </ng-container>
                        <ng-template #movimentoReduzido>
                            {{ 'fatura.texts.estorno_movimento_reduzido' | translate: {
                                codigo: movimento.codigoMovimento,
                                valor: movimento.valorEstornado | number: '1.0-2'
                            } }}
                        </ng-template>
                    </li>
                </ul>

                <div class="flex align-items-center gap-2 mt-3">
                    <p-checkbox inputId="aceiteEstorno" [(ngModel)]="estornoDePagamentosAceito"
                        [binary]="true"></p-checkbox>
                    <label for="aceiteEstorno" class="m-0">
                        {{ 'fatura.labels.estorno_aceite' | translate }}
                    </label>
                </div>
            </div>
        </div>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoMotivoCancelamentoVisivel=false">
            {{ 'fatura.botoes.fechar' | translate }} (Esc)
        </button>
        <button pButton icon="pi pi-trash"
            [disabled]="!podeConfirmarCancelamento"
            (click)="confirmarCancelamento(motivoCancelamentoNfe)">
            {{ 'fatura.botoes.confirmar' | translate }} (Enter)
        </button>
    </ng-template>
</p-dialog>


<p-dialog
    [(visible)]="dialogoMotivoInutilizacaoVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '30rem', height: 'auto' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-ban" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.inutilizar_fatura_eletronica' | translate }}</h2>
                <p>{{ 'fatura.texts.informe_motivo_inutilizacao' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <div class="field">
            <label for="motivoInut">{{ 'fatura.labels.motivo_inutilizacao' | translate }}</label>
            <textarea id="motivoInut" pInputTextarea [(ngModel)]="motivoInutilizacaoNfe" rows="4"
                placeholder="{{ 'fatura.placeholders.digite_motivo_inutilizacao' | translate }}" class="w-full">
            </textarea>
            <small class="text-secondary">{{ 'fatura.labels.minimo_caracteres' | translate: { min: 5 } }}</small>
        </div>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoMotivoInutilizacaoVisivel=false">
            {{ 'fatura.botoes.fechar' | translate }} (Esc)
        </button>
        <button pButton icon="pi pi-ban"
            [disabled]="!motivoInutilizacaoNfe || motivoInutilizacaoNfe.length < 5"
            (click)="inutilizarNfe(motivoInutilizacaoNfe)">
            {{ 'fatura.botoes.confirmar' | translate }} (Enter)
        </button>
    </ng-template>
</p-dialog>

<!-- DIALOGO CONFIRMAR TRANSMISSAO -->
<p-dialog
    [(visible)]="dialogoConfirmarTransmissaoVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '30rem', height: 'auto' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-send" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.confirmar_transmissao' | translate }}</h2>
                <p>{{ 'fatura.texts.confirmar_transmissao_descricao' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <p class="text-center text-700 line-height-3">
            {{ 'fatura.texts.confirmar_transmissao_mensagem' | translate }}
        </p>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoConfirmarTransmissaoVisivel=false">
            {{ 'fatura.botoes.cancelar' | translate }} (Esc)
        </button>
        <button pButton icon="pi pi-send"
            [loading]="isTransmitindo"
            (click)="confirmarTransmissao()"
            pAutoFocus [autofocus]="true">
            {{ 'fatura.botoes.confirmar_transmissao' | translate }} (Enter)
        </button>
    </ng-template>
</p-dialog>

<!-- DIALOGO IMPRIMIR NOTA ELETRONICA (DANFE/KuDE) -->
<p-dialog
    [(visible)]="dialogoImpressaoNfeVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '42rem', height: 'auto' }">

    <!-- HEADER CUSTOMIZADO COM WAVE -->
    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-file-pdf" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogos.imprimir_nota_eletronica' | translate }}</h2>
                <p>{{ 'fatura.texts.selecione_formato_nota' | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO DO DIALOG -->
    <div class="dialog-wave-body">
        <form [formGroup]="tipoDeImpressaoForm">
            <div class="field">
                <label class="mb-3">{{ 'fatura.labels.formato_impressao' | translate }}</label>
                <div class="flex flex-column gap-3">
                    <div class="flex items-center">
                        <p-radioButton name="impressao" value="A4" formControlName="impressao"
                            inputId="impressaoNfeA4"></p-radioButton>
                        <label for="impressaoNfeA4" class="ml-2 font-normal">A4</label>
                    </div>
                    <div class="flex items-center">
                        <p-radioButton name="impressao" value="BOBINA_58" formControlName="impressao"
                            inputId="impressaoNfe58"></p-radioButton>
                        <label for="impressaoNfe58" class="ml-2 font-normal">{{ 'fatura.labels.bobina_58mm' | translate }}</label>
                    </div>
                    <div class="flex items-center">
                        <p-radioButton name="impressao" value="BOBINA_80" formControlName="impressao"
                            inputId="impressaoNfe80"></p-radioButton>
                        <label for="impressaoNfe80" class="ml-2 font-normal">{{ 'fatura.labels.bobina_80mm' | translate }}</label>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- FOOTER -->
    <ng-template pTemplate="footer">
        <button pButton class="p-button-secondary"
            (click)="dialogoImpressaoNfeVisivel=false">
            {{ 'fatura.botoes.cancelar' | translate }} (Esc)
        </button>
        <button pButton icon="pi pi-print"
            [loading]="isImprimindoNfe" (click)="imprimirNotaEletronica()">
            {{ 'fatura.botoes.imprimir' | translate }} (Enter)
        </button>
        <button pButton icon="pi pi-download" severity="success"
            [loading]="isImprimindoNfe" (click)="downloadNotaEletronica()">
            {{ 'fatura.botoes.baixar' | translate }}
        </button>
    </ng-template>
</p-dialog>

<!-- DIALOGO STATUS OPERACAO NFE -->
<p-dialog
    [(visible)]="dialogoOperacaoNfeVisivel"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: temErrosAgrupados ? '550px' : '450px', height: 'auto' }">

    <!-- HEADER WAVE - muda cor conforme estado -->
    <div class="dialog-wave-header"
        [ngClass]="{
            'dialog-wave-header--info': operacaoNfeEstado === 'processando',
            'dialog-wave-header--success': operacaoNfeEstado === 'sucesso',
            'dialog-wave-header--danger': operacaoNfeEstado === 'erro'
        }">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <!-- Icone muda conforme tipo + estado -->
                <i [ngClass]="{
                    'pi pi-send': operacaoNfeTipo === 'transmissao' && operacaoNfeEstado === 'processando',
                    'pi pi-times-circle': operacaoNfeTipo === 'cancelamento' && operacaoNfeEstado === 'processando',
                    'pi pi-search': operacaoNfeTipo === 'consulta' && operacaoNfeEstado === 'processando',
                    'pi pi-ban': operacaoNfeTipo === 'inutilizacao' && operacaoNfeEstado === 'processando',
                    'pi pi-check-circle': operacaoNfeEstado === 'sucesso',
                    'pi pi-exclamation-triangle': operacaoNfeEstado === 'erro'
                }" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{ 'fatura.dialogo_operacao_nfe.titulo_' + operacaoNfeTipo + '_' + operacaoNfeEstado | translate }}</h2>
                <p>{{ 'fatura.dialogo_operacao_nfe.desc_' + operacaoNfeTipo + '_' + operacaoNfeEstado | translate }}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <!-- CORPO -->
    <div class="dialog-wave-body">
        <div class="transmissao-dialog-body">
            <!-- Estado: Processando -->
            <div *ngIf="operacaoNfeEstado === 'processando'" class="transmissao-status">
                <p-progressSpinner [style]="{ width: '60px', height: '60px' }"></p-progressSpinner>
                <p class="transmissao-mensagem">
                    {{ 'fatura.dialogo_operacao_nfe.mensagem_processando' | translate }}
                </p>
            </div>

            <!-- Estado: Sucesso -->
            <div *ngIf="operacaoNfeEstado === 'sucesso'" class="transmissao-status">
                <i class="pi pi-check-circle transmissao-icone-sucesso"></i>
                <p class="transmissao-mensagem transmissao-mensagem--sucesso">
                    {{ 'fatura.dialogo_operacao_nfe.mensagem_sucesso_' + operacaoNfeTipo | translate }}
                </p>
            </div>

            <!-- Estado: Erro -->
            <div *ngIf="operacaoNfeEstado === 'erro'" class="transmissao-status">
                <!-- Erros AGRUPADOS (transmissao com campo grupo) -->
                <ng-container *ngIf="temErrosAgrupados">
                    <p class="transmissao-mensagem mb-3">
                        {{ 'fatura.dialogo_operacao_nfe.mensagem_erro_agrupado' | translate }}
                    </p>

                    <div *ngFor="let grupo of gruposErroNfe" class="erro-grupo">
                        <div class="erro-grupo-titulo">
                            <i [class]="grupo.acoes[0].icone" class="mr-2"></i>
                            {{ grupo.titulo }}
                        </div>
                        <ul class="erro-grupo-lista">
                            <li *ngFor="let erro of grupo.erros">{{ erro.mensagem }}</li>
                        </ul>
                        <div class="erro-grupo-acoes">
                            <button *ngFor="let acao of grupo.acoes"
                                pButton
                                class="p-button-outlined p-button-sm"
                                [icon]="acao.icone"
                                [label]="acao.labelKey | translate"
                                (click)="navegarParaCorrecao(acao)">
                            </button>
                        </div>
                    </div>
                </ng-container>

                <!-- Erros SIMPLES (fallback - cancelamento, inutilizacao, consulta, etc) -->
                <ng-container *ngIf="!temErrosAgrupados">
                    <i class="pi pi-times-circle transmissao-icone-erro"></i>
                    <p class="transmissao-mensagem">
                        {{ 'fatura.dialogo_operacao_nfe.mensagem_erro_' + operacaoNfeTipo | translate }}
                    </p>
                    <p *ngIf="operacaoNfeMensagemErro" class="transmissao-detalhe-erro">
                        {{ operacaoNfeMensagemErro }}
                    </p>
                </ng-container>
            </div>

            <!-- Barra de Progresso (processando e sucesso) -->
            <div *ngIf="operacaoNfeEstado !== 'erro'" class="transmissao-progresso">
                <div class="flex justify-content-between align-items-center mb-2">
                    <span class="text-700 text-sm">{{ 'fatura.dialogo_operacao_nfe.progresso' | translate }}</span>
                    <span class="text-900 font-bold text-sm">{{ operacaoNfeProgresso }}%</span>
                </div>
                <p-progressBar [value]="operacaoNfeProgresso" [showValue]="false"></p-progressBar>
            </div>
        </div>
    </div>

    <!-- FOOTER - so aparece no estado de erro -->
    <ng-template pTemplate="footer">
        <ng-container *ngIf="operacaoNfeEstado === 'erro'">
            <button pButton class="p-button-secondary"
                (click)="fecharDialogoOperacaoNfe()">
                {{ 'fatura.dialogo_operacao_nfe.btn_fechar' | translate }} (Esc)
            </button>
        </ng-container>
    </ng-template>
</p-dialog>
